<template>
  <div class="card card-custom modern-social-card w-100 h-100">
    <div class="card-header border-0 pt-4 pb-0 px-4">
      <div class="card-title m-0">
        <div class="card-label text-center w-100">
          <h6 class="font-weight-bolder text-dark m-0" style="font-size: 1rem;">
            راه‌های ارتباطی و شبکه‌های اجتماعی
          </h6>
          <span class="font-size-sm text-muted mt-2 d-block">
            جهت ارتباط مستقیم یا دنبال کردن، روی شبکه مورد نظر کلیک کنید.
          </span>
        </div>
      </div>
    </div>

    <div class="card-body pt-0 px-3 pb-3 d-flex flex-column align-items-center justify-content-center">
      
      <!-- عکس (پشتیبان / موشک) -->
      <div class="rocket-box">
        <img
          src="../../assets/img/social-media-marketing-landing.webp"
          alt="Social Media"
          class="rocket-img"
        />
      </div>

      <!-- شبکه دکمه‌ها -->
      <div class="social-grid mt-3">
        <a
          v-for="item in socialNetworks"
          :key="item.id"
          :href="item.link"
          target="_blank"
          rel="noopener noreferrer"
          v-b-tooltip.hover="item.title"
          class="social-squircle"
          :class="item.bgClass"
        >
          <div class="svg-icon-wrap" v-html="item.svg"></div>
        </a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "followTerminalAds",
  data() {
    return {
      socialNetworks: [
        {
          id: "instagram",
          title: "اینستاگرام (@terminalAds)",
          link: "https://www.instagram.com/terminalAds/",
          bgClass: "bg-insta",
          svg: `<svg viewBox="0 0 24 24"><path fill="#ffffff" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>`,
        },
        {
          id: "telegram",
          title: "تلگرام (پشتیبانی)",
          link: "https://t.me/qrland999",
          bgClass: "bg-tele",
          svg: `<svg viewBox="0 0 24 24"><path fill="#ffffff" d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>`,
        },
        {
          id: "whatsapp",
          title: "واتساپ (پشتیبانی)",
          link: "https://wa.me/qrland999",
          bgClass: "bg-wa",
          svg: `<svg viewBox="0 0 24 24"><path fill="#ffffff" d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/></svg>`,
        },
        {
          id: "rubika",
          title: "روبیکا (پشتیبانی)",
          link: "https://rubika.ir/qrland999",
          bgClass: "bg-rubika",
          svg: `<svg viewBox="0 0 48.4 48.3" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#ffffff" d="M20.1 1.4c1.3-.7 2.7-1.3 4.2-1.3 0 2.8 0 5.6 0 8.4 0 1 0 2 0 2.9C22.7 10.6 21 9.9 19.4 9c-2.4-1.2-4.7-2.4-7.1-3.6C14.9 4.1 17.5 2.8 20.1 1.4z"/><path fill="#ffffff" d="M24.3.1c1.8 0 3.3.9 4.8 1.6 2.4 1.2 4.7 2.4 7.1 3.7-3.3 1.7-6.6 3.3-10 5-.7.4-1.4.6-2 1 0-1 0-2 0-2.9C24.3 5.8 24.3 2.9 24.3.1z"/><path fill="#ffffff" d="M36.2 5.4c0 4.1.1 8.3 0 12.4-4-2.1-8-4.2-11.9-6.4.6-.4 1.3-.7 2-1 3.3-1.6 6.6-3.3 9.9-5z"/><path fill="#ffffff" d="M4.2 9.7c2.7-1.4 5.4-2.8 8-4.2 0 4.1 0 8.3 0 12.4-1.2-.5-2.4-1.2-3.6-1.8-2.5-1.3-5.1-2.5-7.6-3.9 1.8-1.1 3-1.9 4.2-2.5z"/><path fill="#ffffff" d="M12.3 5.5c2.4 1.1 4.7 2.3 7.1 3.5 1.6.8 3.3 1.6 4.9 2.5-3.9 2.1-7.9 4.2-11.8 6.3 0-4.1 0-8.2-.2-12.3z"/><path fill="#ffffff" d="M36.3 5.5c2.6 1.3 5.2 2.7 7.8 4.1 1.3.7 2.7 1.4 3.4 2.7-3.7 1.9-7.4 3.8-11.2 5.6 0-4.2 0-8.3-.1-12.4z"/><path fill="#ffffff" d="M.5 14.1c.1-.6.3-1.3.7-1.9 2.5 1.3 5 2.6 7.6 3.8 1.2.6 2.4 1.2 3.6 1.8-4 2.1-8 4.3-12 6.4 0-2.1 0-4.2 0-6.3.1-1.2 0-2.5.3-3.8z"/><path fill="#ffffff" d="M36.3 17.9c3.7-1.9 7.4-3.8 11.1-5.6.5.9.7 2 .8 3.1 0 3 0 6 0 9h-.1c-.2-.2-.6-.4-.8-.5-3.6-2.1-7.3-4-11-6z"/><path fill="#ffffff" d="M36.2 17.9c3.8 2 7.4 4 11.1 5.9.3.2.6.3.8.5-4 2-8 4.1-12 6 0-4.1 0-8.3.1-12.4z"/><path fill="#ffffff" d="M.3 24.3c4-2.1 8-4.3 12-6.4 0 4.1 0 8.3 0 12.5-2.4-1.1-4.7-2.4-7.1-3.6C3.6 25.9 1.9 25.1.3 24.3z"/><path fill="#ffffff" d="M.3 24.3c1.6.8 3.2 1.6 4.9 2.5 2.4 1.2 4.7 2.4 7.1 3.6-3.7 2-7.4 3.9-11 5.9-.7-1-.9-2.2-.9-3.3-.1-2.2 0-4.5 0-6.7.1-1.5 0-2.1.1-2.7z"/><path fill="#ffffff" d="M36.2 30.4c4-2 8-4 12-6h.1c0 2.5 0 5.1 0 7.6 0 1.5-.1 3-1 4.3-3.2-1.7-6.3-3.4-9.5-5.1-.5-.7-1-1-1.6-1.2z"/><path fill="#ffffff" d="M1.2 36.2c3.7-2 7.4-3.9 11-5.9 0 4.2 0 8.3 0 12.5-2.1-1.1-4.2-2.2-6.3-3.3-.9-.5-1.7-.9-2.6-1.4-.7-.5-1.5-1.1-2.1-1.9z"/><path fill="#ffffff" d="M12.3 30.4c4 2 8 4.1 12 6.1-4 2.1-8 4.3-12 6.4 0-4.2 0-8.4 0-12.5z"/><path fill="#ffffff" d="M24.3 36.4c4-2 8-4 12-6 0 4.2 0 8.3 0 12.5-4.1-2.2-8-4.3-12-6.5z"/><path fill="#ffffff" d="M36.2 30.4c.5.2 1.1.6 1.6.8 3.2 1.7 6.3 3.4 9.5 5.1-.5.8-1.3 1.3-2.1 1.8-1.2.7-2.5 1.4-3.8 2-1.7.9-3.5 1.8-5.2 2.7 0-4.1.1-8.3 0-12.4z"/><path fill="#ffffff" d="M12.3 42.8c4-2.1 8-4.3 12-6.4 0 3.9 0 7.8 0 11.7-1 0-2-.3-2.9-.7-3.1-1.6-6.1-3.1-9.1-4.6z"/><path fill="#ffffff" d="M24.3 36.4c4 2.1 8 4.2 11.9 6.4-1.3.7-2.7 1.4-4 2.1-1.8.9-3.6 1.8-5.4 2.8-.8.3-1.6.5-2.5.5 0-3.9 0-7.8 0-11.8z"/><path fill="#ffffff" opacity="0.95" d="M24.2 24.1c-1.2-.6-2.3-1.1-3.4-1.7-.8-.4-1.6-.8-2.4-1.2-.9-.5-1.8-.9-2.6-1.3-1.1-.6-2.3-1.1-3.4-1.7L12.3 18c2-1.1 9.9-5.3 11.8-6.3 2.1 1.1 4.2 2.3 6.3 3.4 1.9 1 3.7 2 5.6 3-2.5 1.3-5.1 2.6-7.7 3.9-1.5.7-2.9 1.4-4.3 2.2l.2-.1z"/><path fill="#ffffff" opacity="0.8" d="M12.2 30.4c0-2.8 0-5.5 0-8.3l0-4.1.1-.1.2-.1.2.1v.1c1.3.7 2.7 1.4 4.1 2.1l1.9.9c.8.4 1.6.8 2.4 1.2 1.1.6 2.3 1.2 3.4 1.7l.1.1 0 4.2c0 2.8 0 5.5 0 8.3l-.2.1-11.8-6.2z"/><path fill="#ffffff" opacity="0.9" d="M24.1 36.4c0-3.4 0-6.9 0-10.3l0-2.1.1-.1c1.4-.7 2.9-1.5 4.3-2.2 2.5-1.3 5.1-2.6 7.6-3.9l.2.1v12.5l-.1.1c-2 1-4 2-5.9 3-2 1-4 2-6 3l-.2-.1z"/></svg>`,
        },
        {
          id: "eitaa",
          title: "ایتا (پشتیبانی)",
          link: "https://eitaa.com/qrland999",
          bgClass: "bg-eitaa",
          svg: `<svg viewBox="0 0 48 48"><path fill="#ffffff" d="m9.67.49C11.52-.15,13.51.05,15.44.02c6.27,0,12.54,0,18.81,0,4.34-.24,8.63,1.98,11.13,5.4,1.72,2.22,2.68,5,2.62,7.79-.02,2.2,0,4.41,0,6.61-.04.3.06.73-.29.89-2.17,1.35-3.82,3.32-5.64,5.08-3.33,3.29-6.65,6.96-11.25,8.55-2.52.97-5.29.78-7.85.11-.74,1.59-1.13,3.34-1.17,5.09-2.64-.51-4.97-2.39-6-4.81-.55-1.08-.58-2.3-.78-3.46-.63-.64-1.37-1.18-1.87-1.93-1.31-1.81-1.6-4.28-.68-6.31,1.51-3.42,4.6-5.96,7.99-7.54,2.94-1.45,6.29-2.31,9.59-1.88,2.41.36,4.82,1.67,5.92,3.88.31.58-.13,1.18-.48,1.63-.96,1.09-2.32,1.76-3.67,2.3-2.5.94-5.21,1.51-7.9,1.19-1.12-.18-2.35-.59-2.99-1.57-.55-.87-.35-1.94-.27-2.9-1.86.49-3.09,2.27-3.51,4.03-.42,1.62.45,3.24,1.65,4.3-.81,1.21-1.71,2.44-1.89,3.92-.45,2.83,1.17,5.69,3.68,7.09.05-2.42,1.22-4.76,3.09-6.32,3.6-3.09,8.55-3.96,12.34-6.77,2.53-1.9,3.77-5.05,3.96-8.09.15-2.56-.25-5.27-1.77-7.42-2.11-3.21-6.18-4.86-10-4.62-3.16.08-6.12,1.42-8.75,3.05-5.3,3.45-9.33,8.66-11.39,14.53-1.4,3.88-1.96,8.17-.88,12.19.93,3.75,3.67,7.04,7.27,8.64,4.4,2.12,9.74,2.37,14.28.52,3.86-1.59,6.97-4.48,9.59-7.61,2.56-2.95,4.69-6.22,7.19-9.21.72-.83,1.41-1.75,2.43-2.24.04,2.96,0,5.91.02,8.87,0,1.42.08,2.85-.22,4.26-.71,3.36-2.75,6.44-5.66,8.37-1.97,1.3-4.27,2.15-6.64,2.36-7.08.02-14.16,0-21.24.01-3.57.18-7.19-1.17-9.8-3.55C1.59,41.91-.1,38.16,0,34.4c0-7.14,0-14.29,0-21.44C.03,7.35,4.18,2.08,9.67.49Z"/></svg>`,
        },
        {
          id: "bale",
          title: "بله (پشتیبانی)",
          link: "https://ble.ir/qrland999",
          bgClass: "bg-bale",
          svg: `<svg viewBox="0 0 48 48"><path fill="#ffffff" d="m47.93,22.35C46.76,3.71,25.03-6.45,9.95,4.53c-1.8-1.35-3.61-2.71-5.52-3.9C3.61.06,2.54-.22,1.6.22-.37,1.07.05,3.05.02,4.8c-.01,6.55,0,13.11,0,19.66.12,15.28,15.28,26.73,30.02,22.74,10.97-2.72,18.81-13.58,17.9-24.85Zm-10.49-.85c-3.28,3.27-6.55,6.55-9.83,9.82-1.03,1.03-2.07,2.07-3.1,3.1-.74.81-1.66,1.48-2.75,1.69-1.49.33-3.13-.12-4.23-1.19-.38-.45-7.59-7.51-7.82-7.85-.52-.62-.87-1.38-1.01-2.18-.66-3.19,2.54-6.21,5.69-5.37,2.04.3,4.89,4.14,6.38,5.38,2.66-2.66,5.32-5.32,7.98-7.98,1.24-1.13,2.26-2.54,3.7-3.43,5.28-2.61,9.54,4.31,4.99,8Z"/></svg>`,
        },
        {
          id: "aparat",
          title: "آپارات (QRland)",
          link: "https://www.aparat.com/QRland",
          bgClass: "bg-aparat",
          svg: `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#ffffff" d="M8.51 1.07C9.94.09 11.79-.24 13.47.18c1.25.33 2.51.66 3.76 1-.06 0-.11.03-.16.04-3.13.45-6.14 1.72-8.67 3.64-1.07.81-2.05 1.73-2.92 2.74-.12.14-.23.29-.37.41.02-.1.04-.19.06-.29.29-1.08.57-2.15.86-3.23.39-1.39 1.28-2.63 2.48-3.43Z"/><path fill="#ffffff" d="M31.46 4.96c1.21.31 2.42.64 3.63.96.67.16 1.32.4 1.92.76 1.37.81 2.39 2.19 2.79 3.74.27 1.01.27 2.1 0 3.11-.33 1.24-.66 2.48-.99 3.72-.03.12-.04.25-.12.34-.41-3.37-1.77-6.6-3.85-9.26-.98-1.26-2.13-2.4-3.39-3.37Z"/><path fill="#ffffff" d="M.25 26.27c.29-1.08.56-2.17.87-3.24.57 3.62 2.24 7.05 4.7 9.74.57.63 1.19 1.22 1.84 1.76.15.13.32.25.46.39-1.14-.3-2.29-.61-3.43-.91-.66-.17-1.29-.44-1.87-.81-1.32-.85-2.3-2.24-2.65-3.79-.25-1.03-.21-2.13.08-3.14Z"/><path fill="#ffffff" d="M34.38 32.25c.23-.26.42-.55.66-.8-.24.99-.52 1.97-.77 2.95-.17.62-.3 1.25-.56 1.84-.54 1.28-1.53 2.35-2.75 3.01-1.11.6-2.4.86-3.65.7-.56-.06-1.1-.23-1.64-.37-.72-.19-1.44-.38-2.16-.57-.28-.08-.57-.13-.84-.24 4.52-.64 8.76-3.02 11.71-6.53Z"/><path fill="#ffffff" fill-rule="evenodd" clip-rule="evenodd" d="M19.4 2.67c2.27-.08 4.55.28 6.67 1.08 3.16 1.17 5.96 3.3 7.95 6.04 1.08 1.47 1.92 3.12 2.48 4.86 1.12 3.45 1.12 7.26 0 10.71-.78 2.4-2.1 4.63-3.82 6.47-1.63 1.74-3.61 3.14-5.79 4.09-3.07 1.33-6.51 1.74-9.8 1.18-3.56-.59-6.92-2.35-9.46-4.95-2.46-2.49-4.14-5.75-4.72-9.21-.45-2.64-.29-5.39.49-7.96 1.01-3.36 3.07-6.38 5.8-8.55 2.89-2.32 6.52-3.65 10.21-3.77Zm-5.15 4.69c-.7.12-1.38.39-1.98.79-.91.61-1.6 1.53-1.94 2.58-.35 1.06-.32 2.24.08 3.28.36.96 1.03 1.79 1.87 2.35.95.64 2.11.93 3.24.81 1.44-.13 2.79-.94 3.61-2.14.63-.92.93-2.06.84-3.18-.12-1.64-1.12-3.18-2.56-3.96-.96-.53-2.1-.72-3.18-.54Zm12.7 2.36c-1.07.12-2.09.59-2.87 1.33-1.09 1.02-1.67 2.56-1.52 4.05.1 1.07.56 2.11 1.29 2.9 1.03 1.14 2.61 1.73 4.13 1.57 1.58-.15 3.05-1.11 3.83-2.5.57-1.01.77-2.22.55-3.35-.16-.84-.54-1.63-1.09-2.28-1.04-1.24-2.71-1.9-4.31-1.72Zm-7.4 8.23c-.46.08-.89.31-1.22.64-.4.41-.62.98-.62 1.55 0 .58.25 1.15.66 1.55.45.45 1.1.68 1.73.62.66-.05 1.28-.43 1.65-.99.35-.52.45-1.19.28-1.79-.15-.57-.55-1.06-1.06-1.34-.43-.24-.95-.33-1.43-.25Zm-7.64 2.49c-1.13.14-2.2.69-2.99 1.52-1.07 1.12-1.56 2.77-1.26 4.3.18.97.66 1.88 1.35 2.58 1.12 1.15 2.82 1.69 4.39 1.39 1.48-.26 2.81-1.23 3.51-2.57.49-.93.68-2.03.51-3.08-.15-.96-.6-1.88-1.25-2.59-1.06-1.17-2.7-1.76-4.26-1.56Zm12.61 2.38c-1.67.14-3.24 1.2-3.98 2.72-.48.96-.64 2.09-.43 3.14.17.91.61 1.77 1.25 2.45 1.03 1.12 2.6 1.7 4.1 1.55 1.05-.1 2.07-.56 2.85-1.27 1.1-.99 1.71-2.5 1.6-3.99-.07-1.07-.5-2.1-1.2-2.91-1.02-1.2-2.64-1.85-4.2-1.7Z"/></svg>`,
        },
      ],
    };
  },
};
</script>

<style scoped>
.modern-social-card {
  border-radius: 9px;
  background: #ffffff;
  box-shadow: 0 0 20px 0 rgba(82, 63, 105, 0.05);
  overflow: hidden;
}


.social-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  width: 100%;
}
/* دکمه‌های شبکه‌های اجتماعی */
.social-squircle {
  width: 32px;
  height: 32px;
  border-radius: 11px; 
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.social-squircle:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15);
}

/* آیکون داخل دکمه‌ها */
.svg-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px; 
  height: 24px;
}

.svg-icon-wrap >>> svg {
  width: 100% !important;
  height: 100% !important;
  display: block;
}

/* گرادینت‌ها */
.bg-insta { background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285aeb 90%); }
.bg-tele { background: linear-gradient(135deg, #2aabee 0%, #229ed9 100%); }
.bg-wa { background: linear-gradient(135deg, #25d366 0%, #128c7e 100%); }
.bg-rubika { background: linear-gradient(135deg, #ff8000 0%, #e65100 100%); }
.bg-eitaa { background: linear-gradient(135deg, #ff7043 0%, #d84315 100%); }
.bg-bale { background: linear-gradient(135deg, #1eb686 0%, #00897b 100%); }
.bg-aparat { background: linear-gradient(135deg, #ea1d5d 0%, #c21347 100%); }

.rocket-box {
  height: 100px; 
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.rocket-img {
  max-height: 100%;
  width: auto;
  object-fit: contain;
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.12));
  animation: floatRocket 3s ease-in-out infinite;
}

@keyframes floatRocket {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}
.modern-social-card {
  border-radius: 9px;
  background: #ffffff;
  box-shadow: 0 0 20px 0 rgba(82, 63, 105, 0.05);
  overflow: hidden;
  transform: none !important;
  perspective: none !important;
}

.modern-social-card:hover {
  transform: none !important;
}
.no-flip-card,
.no-flip-card:hover {
  transform: none !important;
  perspective: none !important;
  transition: none !important; 
}
.no-flip-card:hover,
.card-custom.no-flip-card:hover {
  transform: none !important;
  -webkit-transform: none !important;
  box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05) !important;
}
</style>
